import { createSlice } from '@reduxjs/toolkit';
export const buttonSlice = createSlice({
  name: 'buttonSlice',
  initialState: {
    showGrid: true,
    showApply: false,
    showApplyReco: false,
    restrictValue: false,
    tabFlag: true
  },
  reducers: {
    pushShowGrid: (state, action) => {
      state.showGrid = action.payload;
    },
    pushShowApply: (state, action) => {
      state.showApply = action.payload;
    },
    pushShowApplyReco: (state, action) => {
      state.showApplyReco = action.payload;
    },
    pushConditionalTab: (state, action) => {
      state.tabFlag = action.payload;
    },
    pushRestrictValue: (state, action) => {
      state.restrictValue = action.payload;
    }
  }
});
export const {
  pushShowGrid,
  pushShowApply,
  pushShowApplyReco,
  pushRestrictValue,
  pushConditionalTab
} = buttonSlice.actions;
export default buttonSlice.reducer;